import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';

export default class HexagonConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'side_length',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {

		// See https://en.wikipedia.org/wiki/Hexagon#Parameters
		// The shortest side is the d, now we need to calculate R.
		// r = 0.5d
		// r = ( sqrt(3) / 2 ) * R
		// r / ( sqrt(3) / 2 ) = R
		// R = r / ( sqrt(3) / 2 )
		const shortest_side = maximum_rectangle.get_shortest_side().in_mm() / 2;

		const maximum_side_length = shortest_side / (
			Math.sqrt( 3 ) / 2
		);

		return {
			side_length: new Length( maximum_side_length )
		};
	}

	get_labels(): Record<string, string> {
		const { side_length } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			side_length,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			side_length: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'straight';
	}
}
